export default {
  data() {
    return {
      loading: false,
      data: {}
    }
  },
  props: ['carNo'],

  created() {
    this.$watch('carNo' , function(nv){
      if(nv){
        this.query()
      }else{
        this.data = {}
      }
    },{immediate:true})
  },
  methods: {
    query() {
      this.loading = true
      this.$request.partnerCarFinance(this.carNo).then(resp => {
        this.loading = false
        if (resp.code == 0) {
          this.data = this.$utils.conv(resp.data , {'startDatetime':'datetime' , 'buyOptions':'buyOptions' , 'clearingType':'clearingType' , 'lastBillDateTime':'datetime'})

        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
  },
  render() {
    const data = this.data || {}
    return (
      <sl-detail-list col={1} label-width="130px" label-align="right" style="padding:12px;">
        <sl-detail-list-item title="购车方案">{data.buyOptionsText}</sl-detail-list-item>
        <sl-detail-list-item title="结算周期">{data.clearingTypeText}</sl-detail-list-item>
        <sl-detail-list-item title="每期价格">{data.stagesPrice}</sl-detail-list-item>
        <sl-detail-list-item title="金融公司">{data.companyName}</sl-detail-list-item>
        <sl-detail-list-item title="开始计费时间">{data.startDatetimeText}</sl-detail-list-item>
        <sl-detail-list-item title="最近扣费时间">{data.lastBillDateTimeText}</sl-detail-list-item>
        <sl-detail-list-item title="已扣费期数/总期数">{Math.round(data.stagesNum - data.repayStagesNum).toFixed(0)} / {data.stagesNum}</sl-detail-list-item>
        <sl-detail-list-item title="已扣费金额/总金额">{Math.round(100 * (data.totalAmount - data.repayAmount)) / 100} / {data.totalAmount}</sl-detail-list-item>
      </sl-detail-list>
            
    )
  }
}
